import apiClient from "@/api/client";
import type { OrderAuditEvent } from "../types";

export const orderEventsApi = {
  list: (orderId: string, limit = 200) =>
    apiClient
      .get<{ data: OrderAuditEvent[]; meta: { count: number; has_more: boolean } }>(
        `/orders/${orderId}/events/`,
        { params: { limit } },
      )
      .then((r) => r.data.data),
};
